// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning[data-v-c342fe22]{color:#dc5353;font-weight:700}", ""]);
// Exports
module.exports = exports;
